var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoBillcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 24,
    viewBox: "0 0 100 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4399 7.704H17.8799V23.424H22.4399V7.704Z",
    fill: "#EF7E19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4321 0.287994H25.8721V23.424H30.4321V0.287994Z",
    fill: "#EF7E19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4243 0.287994H33.8643V23.424H38.4243V0.287994Z",
    fill: "#EF7E19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1842 0C18.6722 0 17.4482 1.224 17.4482 2.736C17.4482 4.248 18.6722 5.472 20.1842 5.472C21.6962 5.472 22.9202 4.248 22.9202 2.736C22.9202 2.016 22.6322 1.32 22.1042 0.792C21.6002 0.288 20.9042 0 20.1842 0Z",
    fill: "#EF7E19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.432V0.479996L12.096 4.968C13.368 5.904 14.232 7.248 14.568 8.784C13.2 7.152 11.352 6.456 10.104 6.432H6Z",
    fill: "#F6B881"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0082 18C9.96023 18.72 9.36023 19.272 8.64023 19.272H4.75223V11.784H8.64023C9.36023 11.784 9.96023 12.336 10.0082 13.056V18ZM4.77623 7.70399V0.287994H0.240234V23.424H9.74423C11.0162 23.424 12.2642 22.92 13.1762 22.008C14.0882 21.096 14.5922 19.872 14.5922 18.576V12.552C14.5922 9.88799 12.4322 7.72799 9.74423 7.72799H4.77623V7.70399Z",
    fill: "#EF7E19"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.432 23.88C46.776 23.88 45.624 20.976 45.624 18.408V12.768C45.624 9.648 47.28 7.272 51.384 7.272C55.416 7.272 56.856 9.192 56.856 11.784V13.104H54.48V12C54.48 10.464 53.688 9.288 51.456 9.288C48.864 9.288 48.096 10.656 48.096 12.768V18C48.096 20.088 48.96 21.768 51.504 21.768C53.736 21.768 54.528 20.712 54.528 19.152V18.096H56.904V19.248C56.856 21.888 55.272 23.88 51.432 23.88Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0642 23.88C60.4802 23.88 59.1602 21.216 59.1602 18.216V13.032C59.1602 10.272 60.5762 7.272 65.2562 7.272C69.9362 7.272 71.2082 10.176 71.2082 12.888V18.168C71.2082 20.904 70.0562 23.88 65.0642 23.88ZM65.2562 21.792C67.9682 21.792 68.7602 20.136 68.7602 18.024V13.032C68.7602 11.064 68.0642 9.384 65.2562 9.384C62.5442 9.384 61.6082 11.04 61.6082 13.128V18C61.6082 20.352 62.4962 21.792 65.2562 21.792Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9199 23.424V7.728H76.0799L76.1519 9.912C76.8479 8.568 78.3599 7.296 80.7839 7.296C83.2559 7.296 84.5279 8.568 85.0559 10.056C85.9919 8.304 87.8159 7.248 89.7839 7.296C93.3119 7.296 94.3679 9.816 94.3679 12.264V23.424H91.9679V12.912C91.9679 10.968 91.4639 9.408 89.1119 9.408C88.1519 9.36 87.2159 9.696 86.5199 10.344C85.8239 10.992 85.3919 11.904 85.3679 12.864V23.448H82.9199V12.672C82.9199 10.968 82.4159 9.384 80.0639 9.384C79.1039 9.336 78.1679 9.696 77.4719 10.344C76.7759 10.992 76.3439 11.904 76.3199 12.84V23.424H73.9199Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3603 23.904C43.3013 23.904 44.0643 23.1411 44.0643 22.2C44.0643 21.2589 43.3013 20.496 42.3603 20.496C41.4192 20.496 40.6562 21.2589 40.6562 22.2C40.6562 23.1411 41.4192 23.904 42.3603 23.904Z",
    fill: "#CCCCCC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBillcom);
export default __webpack_public_path__ + "static/media/logo_billcom.74c2cfb1b317c18083feee9d495e8b17.svg";
export { ForwardRef as ReactComponent };